// services/language.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Language {
  code: string;
  name: string;
  flag: string;
  secondaryFlag?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private languageSubject = new BehaviorSubject<Language>({
    code: 'EL',
    name: 'Greek',
    flag: 'assets/flags/greece.png'
  });

  public currentLanguage$: Observable<Language> = this.languageSubject.asObservable();

  constructor() {
    // Initialize from localStorage if available
    const savedLang = localStorage.getItem('selectedLang');
    if (savedLang) {
      const languages: Language[] = [
        { code: 'EN', name: 'English', flag: 'assets/flags/united-kingdom.png' },
        { code: 'EL', name: 'Greek', flag: 'assets/flags/greece.png' },
      ];
      
      const foundLang = languages.find(lang => lang.code === savedLang.toUpperCase());
      if (foundLang) {
        this.languageSubject.next(foundLang);
      }
    }
  }

  setLanguage(language: Language): void {
    this.languageSubject.next(language);
    localStorage.setItem('selectedLang', language.code.toLowerCase());
  }

  getCurrentLanguage(): Language {
    return this.languageSubject.value;
  }
}